import { LucideMinus } from 'lucide-react'
import { Button, Input } from '~/components/ui'
import { cn } from '~/utils'

export default function MapDateFilter({
  className,
  name,
  label,
  filterValue,
  updateFilter,
}: {
  className?: string
  name: string
  label: string
  filterValue: (string | undefined)[]
  updateFilter: (updates: Record<string, any>) => void
}) {
  return (
    <div className={cn('space-y-2', className)}>
      <p className="text-sm">
        {label}
        {filterValue && (filterValue[0] || filterValue[1]) && (
          <Button
            variant="link"
            size="none"
            className="ml-2"
            onClick={() => {
              updateFilter({ [name]: undefined })
            }}>
            (reset)
          </Button>
        )}
      </p>

      <div className="flex items-center justify-stretch gap-2 pr-2">
        <div>
          <Input
            type="date"
            value={filterValue[0] ?? ''}
            onChange={(e) => {
              const from = e.target.value
              updateFilter({ [name]: [from, filterValue[1]] })
            }}
          />
          <p className="ml-1 pt-1 text-sm">From</p>
        </div>
        <div className="mx-2 mb-4 text-muted-foreground">
          <LucideMinus className="-mx-1 h-3 w-3" />
        </div>
        <div>
          <Input
            type="date"
            value={filterValue[1] ?? ''}
            onChange={(e) => {
              const to = e.target.value
              updateFilter({ [name]: [filterValue[0], to] })
            }}
          />
          <p className="ml-1 pt-1 text-sm">To</p>
        </div>
      </div>
    </div>
  )
}
